import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import { SectionImpressionTrackingInfo } from "@services/tracking/types/trackingInfo/sectionImpressionTrackingInfo";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo,
} from "../GoogleAnalyticsMinimumDataset";

export interface GoogleAnalyticsSectionImpression
    extends GoogleAnalyticsMinimumDataset {
    info: {
        name: string;
        category: string;
        type: string;
        placement: string;
        target: string;
        variant?: string;
    };
}

const getGoogleAnalyticsSectionImpression = (
    data: TypedAnalyticsEvent<SectionImpressionTrackingInfo>,
): GoogleAnalyticsSectionImpression | undefined => {
    let gtmData = {
        event: GoogleAnalyticsEvents.SectionImpression,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        info: {
            name: data?.payload.eventData?.name,
            category: data?.payload.eventData?.category,
            type: data?.payload.eventData?.type,
            placement: data?.payload.eventData?.placement,
            target: "", // TODO wat voor waarde is dit?
        },
    };

    // minimum data present
    if (gtmData?.info?.name) {
        return gtmData;
    } else {
        return undefined;
    }
};

export { getGoogleAnalyticsSectionImpression };
